import React from 'react';

const AmoebaForm = ({children, style}) => (
  <form
    acceptCharset='UTF-8'
    action={process.env.REACT_APP_AMOEBA_URL}
    method='get'
    style={style}
  >
    {children}
  </form>
);

export default AmoebaForm;
